/**
 * Room configuration — the 9 rooms of JohnicornOS.
 * Each room has a path, label, icon (emoji), accent color,
 * and whether it's active or a placeholder.
 */

export interface RoomConfig {
  id: string;
  path: string;
  label: string;
  icon: string;
  accentHue: number;     // HSL hue for per-room accent
  accentColor: string;   // CSS HSL value
  active: boolean;       // false = "Coming Soon" placeholder
  description: string;
}

export const ROOMS: RoomConfig[] = [
  {
    id: 'dashboard',
    path: '/',
    label: 'Dashboard',
    icon: '🏠',
    accentHue: 16,
    accentColor: '#FF4500',   // Ember
    active: true,
    description: 'Your mission control center',
  },
  {
    id: 'health',
    path: '/health',
    label: 'Health Room',
    icon: '💚',
    accentHue: 145,
    accentColor: '#4A9D6E',   // Sage
    active: true,
    description: 'Track habits, mood, sleep, exercise & nutrition',
  },
  {
    id: 'wealth',
    path: '/wealth',
    label: 'Wealth Room',
    icon: '💰',
    accentHue: 210,
    accentColor: '#1B3A5C',   // Navy
    active: true,
    description: 'Manage accounts, budgets & savings goals',
  },
  {
    id: 'business',
    path: '/business',
    label: 'Business Room',
    icon: '🚀',
    accentHue: 160,
    accentColor: '#10B981',   // Emerald
    active: true,
    description: 'CRM, pipeline, invoices & focus tasks',
  },
  {
    id: 'journal',
    path: '/journal',
    label: 'Journal',
    icon: '📝',
    accentHue: 320,
    accentColor: '#6B2D5B',   // Plum
    active: true,
    description: 'Notes, reflections, templates & scratch pad',
  },
  {
    id: 'game',
    path: '/game',
    label: 'Game Room',
    icon: '🎮',
    accentHue: 50,
    accentColor: 'hsl(50, 90%, 50%)',    // Gold
    active: true,
    description: 'XP, badges, skill tree & daily challenges',
  },
  {
    id: 'tools',
    path: '/tools',
    label: 'Tools',
    icon: '🛠️',
    accentHue: 190,
    accentColor: 'hsl(190, 60%, 50%)',   // Teal
    active: false,
    description: 'Utilities, calculators & productivity tools',
  },
  {
    id: 'content',
    path: '/content',
    label: 'Content Calendar',
    icon: '📅',
    accentHue: 0,
    accentColor: 'hsl(0, 70%, 55%)',     // Red
    active: false,
    description: 'Plan and schedule content across platforms',
  },
  {
    id: 'smarthome',
    path: '/smarthome',
    label: 'Smart Home',
    icon: '🏡',
    accentHue: 160,
    accentColor: 'hsl(160, 50%, 50%)',   // Mint
    active: false,
    description: 'IoT integrations & home automation',
  },
];

/**
 * Find a room config by its path.
 */
export function getRoomByPath(path: string): RoomConfig | undefined {
  return ROOMS.find((r) => r.path === path);
}

/**
 * Find a room config by its id.
 */
export function getRoomById(id: string): RoomConfig | undefined {
  return ROOMS.find((r) => r.id === id);
}
